import Box from "@mui/material/Box";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import makeStyles from "@mui/styles/makeStyles";
import useTheme from "@mui/styles/useTheme";

import React from "react";
import classnames from "classnames";

import { COMPACT_VIEWPORT } from "../../theme";

interface IListItemProps {
  className?: string;
  onClick?: (arg?: any) => any;
  primary: string | React.ReactNode;
  secondary?: string | React.ReactNode;
  secondaryAction?: React.ReactNode;
  selected?: boolean;
  linkTo?: string;
  linkComponent?: any;
  noWrap?: boolean;

  [any: string]: any;
}

const useStyles = makeStyles((theme) => ({
  // needed for ul>li structure (on Layers tab)
  container: {
    "&:last-child div": {
      borderBottom: "none",
    },
  },
}));

export function ListItem(props: IListItemProps) {
  const {
    className,
    linkComponent,
    linkTo,
    onClick,
    primary,
    secondary,
    secondaryAction,
    selected,
    noWrap = true,
    ...rest
  } = props;

  const theme = useTheme();
  const classes = useStyles(props);

  const listItemProps: any = {
    onClick,
    sx: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      [COMPACT_VIEWPORT]: {
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        "& .marapp-qa-list-item-title": {
          fontSize: "0.875rem",
        },
        "& .marapp-qa-list-item-description": {
          fontSize: "0.75rem",
        },
      },
      "&:last-child": {
        borderBottom: "none",
      },
    },
    classes: { container: classes.container },
    className: classnames(className, "marapp-qa-listitem"),
    selected,

    // Only use `component` for non-link cases to avoid ref warnings
    // with connect()-wrapped link components (e.g. redux-first-router-link)
    ...(!linkComponent && { component: "div" }),
    ...(linkTo &&
      !linkComponent && {
        to: linkTo,
      }),
  };

  const button = (
    <ListItemButton {...listItemProps} {...rest}>
      <Box
        sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <ListItemText
            sx={{
              wordBreak: "break-word",
              overflowWrap: "break-word",
              ...(!noWrap && {
                "& .marapp-qa-list-item-title": {
                  whiteSpace: "normal",
                  overflow: "visible",
                },
                "& .marapp-qa-list-item-description": {
                  whiteSpace: "normal",
                  overflow: "visible",
                },
              }),
            }}
            primary={primary}
            secondary={secondary}
            slotProps={{
              primary: {
                className: "marapp-qa-list-item-title",
                noWrap: noWrap,
              },
              secondary: {
                className: "marapp-qa-list-item-description",
                noWrap: noWrap,
              },
            }}
          />
        </Box>

        {secondaryAction && <Box sx={{ flex: "none" }}>{secondaryAction}</Box>}
      </Box>
    </ListItemButton>
  );

  if (linkComponent) {
    const LinkComponent = linkComponent;
    return React.createElement(
      LinkComponent,
      { to: linkTo, style: { textDecoration: "none", color: "inherit" } },
      button
    );
  }

  return button;
}
